/** 丹炉 */

import { gql } from '@apollo/client'

/** 检查兑换码是否可用 */
export const CHECK_REDEEM_CODE = gql`
  query checkRedeemCode($code: String) {
    marketingModule {
      checkAndQueryUserCoupon(code: $code) {
        code
        id
        status
        type
      }
    }
  }
`

/** 获取可用于创建机器的gpu列表 */
export const GET_GPU_LIST = gql`
  fragment fields on ProductItem {
    id
    name
    desc
    skuList {
      skuId
      name
      price
      showPrice
      spec {
        property
        name
        ext
      }
    }
  }
  query getGpuList {
    itemModule {
      productItemPage(
        page: { first: 100, offset: 0 }
        param: { type: 1, status: 1 }
      ) {
        edges {
          node {
            ...fields
          }
        }
      }
    }
  }
`

/** 下单 */
export const BUY_GPU_TIME = gql`
  mutation buyGpuTime($input: DanluRechargeInput) {
    orderModule {
      danluRecharge(input: $input) {
        needPay
        orderId
        orderNo
        payInfo
        payType
      }
    }
  }
`

/** 支付结果轮询 */
export const POLL_PAY_GPU_RESULT = gql`
  query pollPayGpuResult($orderNo: String) {
    orderModule {
      status: danluRechargeResult(orderNo: $orderNo)
    }
  }
`

/** 创建丹炉 */
export const CREATE_DANLU = gql`
  mutation createDanlu($input: AiDanluCreateInput!) {
    aiDanluMutation {
      id: createAiDanlu(input: $input)
    }
  }
`

/** 通过兑换码创建丹炉 */
export const CREATE_DANLU_BY_CODE = gql`
  mutation createDanluByCode($input: AiDanluCreateByConversionCodeInput!) {
    aiDanluMutation {
      id: createAiDanluByConversionCode(input: $input)
    }
  }
`

/** 更新丹炉 */
export const UPDATE_DANLU = gql`
  mutation updateDanlu($key: String!, $input: AiDanluUpdateParam!) {
    aiDanluMutation {
      id: updateAiDanlu(danluKey: $key, param: $input)
    }
  }
`

/** 开启丹炉,成功返回true，失败抛异常 */
export const START_DANLU = gql`
  mutation startDanlu($key: String!) {
    aiDanluMutation {
      status: startAiDanlu(danluKey: $key)
    }
  }
`

/** 关闭丹炉,成功返回true，失败抛异常 */
export const CLOSE_DANLU = gql`
  mutation closeDanlu($key: String!) {
    aiDanluMutation {
      status: shutDownAiDanlu(danluKey: $key)
    }
  }
`

/** 删除丹炉,成功返回true，失败抛异常 */
export const DELETE_DANLU = gql`
  mutation deleteDanlu($key: String!) {
    aiDanluMutation {
      status: delAiDanlu(danluKey: $key)
    }
  }
`

/** 单个丹炉信息 */
export const GET_DANLU = gql`
  query getDanlu($key: String!) {
    aiDanluGraph {
      aiDanlu(danluKey: $key) {
        # aiSnapshotInfo {
        #   type
        #   name
        #   desc
        # }
        aiGpuInfo {
          id
          name
        }
        attachLink
        danluKey
        name
        status
        remainingTime
      }
    }
  }
`

/** 用 [id, ...] 获取多个丹炉的信息 */
export const GET_DANLUS = gql`
  query getDanlus($keys: [String!]!) {
    aiDanluGraph {
      aiDanlus(danluKeys: $keys) {
        # aiSnapshotInfo {
        #   type
        #   name
        #   desc
        # }
        aiGpuInfo {
          id
          name
        }
        attachLink
        danluKey
        name
        status
        remainingTime
      }
    }
  }
`

/** 丹炉信息列表 */
export const GET_DANLU_LIST = gql`
  query getDanluList($first: Int, $offset: Int) {
    aiDanluGraph {
      aiDanluList(page: { first: $first, offset: $offset }) {
        edges {
          node {
            # aiSnapshotInfo {
            #   type
            #   name
            #   desc
            # }
            aiGpuInfo {
              id
              name
            }
            attachLink
            danluKey
            name
            status
            remainingTime
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`

/** 丹炉操作记录列表 */
export const GET_DANLU_OP_LIST = gql`
  query getDanluOpList($first: Int, $offset: Int, $key: String!) {
    aiDanluGraph {
      aiDanluOperationLogList(
        page: { first: $first, offset: $offset }
        param: { danluKey: $key }
      ) {
        edges {
          node {
            id
            causeTime
            info
            type
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`

export const FURNACE_ORDER_LIST = gql`
  query furnaceOrderList(
    $first: Int
    $offset: Int
    $param: DanluRechargeOrderQueryInput
  ) {
    orderModule {
      myDanluRechargeOrderPage(
        page: { first: $first, offset: $offset }
        param: $param
      ) {
        edges {
          node {
            cstCreated
            id: orderId
            danLuName
            orderNo
            payChannel
            rechargeAmount
            status
            unpayCloseTime
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`

/** 支付订单 */
export const PAY_GPU_ORDER = gql`
  mutation payGpuOrder($orderNo: String, $input: PayTypeInput) {
    orderModule {
      danluRechargeOrderPay(orderNo: $orderNo, payTypeInfo: $input) {
        needPay
        orderId
        orderNo
        payInfo
        payType
      }
    }
  }
`
